export const STATUS_META = {
  active: { label: "Aktif", className: "bg-success-lt" },
  cancelled: { label: "Dibatalkan", className: "bg-danger-lt" },
};

export const formatDate = (value) => value
  ? new Intl.DateTimeFormat("id-ID", { day: "2-digit", month: "short", year: "numeric" }).format(new Date(`${String(value).slice(0, 10)}T00:00:00`))
  : "-";

export const formatDateTime = (value) => value
  ? new Intl.DateTimeFormat("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(value))
  : "-";

export const localDate = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 10);
};
